import React, { createContext, useContext, useState, useEffect } from 'react';
import { getTheme, saveTheme, getSettings, saveSettings } from '../utils/storage';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState('light');
  const [settings, setSettingsState] = useState({
    focusMode: false,
    showProgress: true,
    enableNotifications: false
  });

  useEffect(() => {
    const savedTheme = getTheme();
    const savedSettings = getSettings();
    setThemeState(savedTheme);
    setSettingsState(savedSettings);

    // Apply theme to document
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const setTheme = (newTheme) => {
    setThemeState(newTheme);
    saveTheme(newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  const updateSettings = (newSettings) => {
    const updatedSettings = { ...settings, ...newSettings };
    setSettingsState(updatedSettings);
    saveSettings(updatedSettings);
  };

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
  };

  return (
    <ThemeContext.Provider value={{
      theme,
      setTheme,
      toggleTheme,
      settings,
      updateSettings
    }}>
      {children}
    </ThemeContext.Provider>
  );
};
